"use strict";

// Серверные урлы, которые нужны в клиентской части.

function Url(pattern) {
    var self = this;
    self.pattern = pattern;
    self.re = new RegExp(pattern);
    self.getUrl = function (id) {
        if (id) {
            return self.pattern.replace("(\\d+)", id);
        } else {
            return self.pattern;
        }
    };
    self.getId = function (url) {
        var matches = self.re.exec(url);
        return (matches && matches[1]) || undefined;
    };
}

export default {
    process: {
        cancel: new Url("/clean/document/cancel/"),
        estimate: new Url("/clean/document/(\\d+)/estimate/"),
        preview: new Url("/clean/document/(\\d+)/preview/"),
        progress: new Url("/clean/document/(\\d+)/progress/"),
        upload: new Url("/clean/document/upload/"),
    },
    api: {
        demo: new Url("/demo/v2"),
        demoClean: new Url("/demo/v2/clean"),
        demoProxy: new Url("/_/demo"),
    },
    merging: {
        cancel: new Url("/merging/merge/(\\d+)/cancel/"),
        result: new Url("/merging/merge/(\\d+)/"),
        status: new Url("/merging/merge/(\\d+)/status/"),
        upload: new Url("/merging/upload-document/"),
    },
};
